import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ReactTooltip from 'react-tooltip';
import {
    DKLabel,
    Toggle,
    DKIcon,
    DKButton,
    DKInput,
    DKCheckMark,
    DKLine,
    showLoader,
    removeLoader,
    showToast,
    showAlert,
    TOAST_TYPE,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import INComplianceService from "../../../../services/compliance/INComplianceService";
import RouteManager from "../../../../managers/RouteManager";
import { PAGE_ROUTES } from "../../../../managers/RouteManager";
import { TENANT, TenantService } from "../../../../managers/TenantManagerService";
import { DATE_FORMAT, INPUT_TYPE } from "../../../../constants/Constant";
import ic_info_warning from "../../../../assets/icons/ic_info_gray.svg";
import ic_delete from "../../../../assets/icons/ic_delete.png";
import { Countries, IN_STATES } from "../../../../constants/CountryConstant";
import { deepClone } from "../../../../utility/Utility";
import { PAN_REGEX_PATTERN } from "../../../../constants/RegexConstants";
import moment from "moment";
import FileUpload from "../../../common/FileUpload";
import ic_attachment from "../../../../assets/icons/ic_attachment.png";
import ic_document from "../../../../assets/icons/ic_document.png";
import AttachmentService, { Entity } from "../../../../services/AttachmentService";
import ic_close from "../../../../assets/icons/ic_close.png";
import { saveAs } from 'file-saver';
import AppManager from "../../../../managers/AppManager";
import { getQueryParam } from "../../../../managers/common/CommonUtil";
import { INVESTMENT_STAGE } from "./InvestmentConstants";
import FormatCurrencyService from "../../../../services/FormatCurrencyService";
import { isViewportLarge } from "../../../../utility/ViewportSizeUtils";
import PermissionUtils, { ACTION, MODULE } from "../../../user-permissions/PermissionUtils";
import i18next from "i18next";

function MyActual(props) {
    const history = useHistory();

    const INVESTMENT_STATUS = {
        ACTUAL: "ACTUAL",
        DECLARATION: "DECLARATION",
        DRAFT: "DRAFT",
        SUBMITTED: "SUBMITTED",
        PENDING: "PENDING",
        APPROVED: "APPROVED",
        REJECTED: "REJECTED"
    };

    const employeeData = getQueryParam(props.location, "employeeData");
    const userId = props.userId || getQueryParam(props.location, "id");
    const employeeName = props.employeeName || getQueryParam(props.location, "name");
    const isMyPOI = TenantService.get(TENANT.USER_ID) === userId;

    const SECTION = {
        FINANCIAL_YEAR: "financialYear",
        REGIME: "regime",
        HOUSE_RENT: "houseRent",
        HOME_LOAN: "homeLoan",
        RENTAL_INCOME: "rentalIncome",
        INVESTMENT_80C: "investment80C",
        INVESTMENT_80D: "investment80D",
        OTHER_INVESTMENT: "otherInvestment",
        OTHER_INCOME: "otherIncome"
    };

    const METRO_CITIES = ["110", "400", "600", "700"];

    const width = "20%";
    const marginRight = "20px";

    const getFinancialYears = () => {
        const years = [];

        const todayYear = moment().year();
        const todayMonth = moment().month();

        let startYear = todayMonth > moment().month("March").month() ? todayYear : todayYear - 1;
        const endYear = todayMonth > moment().month("March").month() ? todayYear + 1 : todayYear;

        const dateOfCreation = TenantService.get(TENANT.DATE_OF_CREATION);
        if (dateOfCreation) {
            const dateOfCreationYear = moment(dateOfCreation, DATE_FORMAT.YYYYMMDD).year();
            if (dateOfCreationYear < startYear) {
                startYear = dateOfCreationYear;
            }
        }

        while(startYear !== endYear) {
            years.push(String().concat(startYear, " - ", startYear + 1));
            startYear++;
        }

        return years;
    }

    const getFinancialYearStartDate = () => {
        let startDate = null;

        const selectedFinancialYear = getSelectFieldValue(financialYear.financialYear, financialYears);
        if (selectedFinancialYear) {
            startDate = moment([selectedFinancialYear.split(" - ")[0], 3, 1]);
        }

        return startDate;
    }

    const getFinancialYearEndDate = () => {
        let endDate = null;

        const selectedFinancialYear = getSelectFieldValue(financialYear.financialYear, financialYears);
        if (selectedFinancialYear) {
            endDate = moment([selectedFinancialYear.split(" - ")[1], 2, 31]);
        }

        return endDate;
    }

    const getCurrentFinancialYear = () => {
        const todayYear = moment().year();
        const todayMonth = moment().month();

        const startYear = todayMonth > moment().month("March").month() ? todayYear : todayYear - 1;
        const endYear = todayMonth > moment().month("March").month() ? todayYear + 1 : todayYear;

        return `${startYear} - ${endYear}`;
    }

    const financialYears = getFinancialYears();
    const defaultFinancialYear = [financialYears.length - 1];
    const currentFinancialYear = getCurrentFinancialYear();

    const states = IN_STATES.map(s => s.label);
    const countries = Countries.map(c => c.label);

    const getDefaultFieldConfig = (type, name, value, validation, options, readOnly, disabled, tooltip) => {
        return {
            type: type,
            name: name,
            value: value,
            validation: validation,
            invalid: false,
            errorMsg: null,
            options: options,
            readOnly: !!readOnly,
            disabled: !!disabled,
            tooltip: tooltip
        }
    }

    const getAttachmentConfig = () => {
        return {
            show: false,
            files: []
        }
    }

    const regimeOptions = [
        {name: "Old Tax Regime", value: false},
        {name: "New Tax Regime", value: true}
    ];

    const initialFinancialYearState = {
        financialYear: getDefaultFieldConfig(INPUT_TYPE.DROPDOWN, "Financial Year", defaultFinancialYear, [["required"]], financialYears)
    };

    const initialRegimeState = {
        newRegime: getDefaultFieldConfig("radio", "Regime", false, [[]], regimeOptions)
    };

    const initialHouseRentState = {
        rentalFromDate: getDefaultFieldConfig(INPUT_TYPE.DATE, "From", null, [["required"]]),
        rentalToDate: getDefaultFieldConfig(INPUT_TYPE.DATE, "To", null, [["required"]]),
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Amount", "0", [["required"]]),
        addressLine1: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Address Line 1", null, [["required"]]),
        addressLine2: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Address Line 2", null, [[]]),
        zipCode: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Zipcode", null, [["required"]]),
        city: getDefaultFieldConfig(INPUT_TYPE.TEXT, "City", null, [["required"]]),
        state: getDefaultFieldConfig(INPUT_TYPE.SELECT, "State", null, [["required"]], states),
        country: getDefaultFieldConfig(INPUT_TYPE.SELECT, "Country", [0], [["required"]], countries, true),
        landlordName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Landlord Name", null, [["required"]]),
        landlordPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Landlord PAN", null, [["pattern", PAN_REGEX_PATTERN]], null, false, false, "The PAN should follow the pattern SSSSS0000S where S-Alphabet, 0-Number"),
        isMetroCity: getDefaultFieldConfig(INPUT_TYPE.CHECKBOX, "Metro", false, [[]], null, true),
        amountAttachments: getAttachmentConfig(),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        comments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]])
    };

    const initialHomeLoanState = {
        homeLoanPrincipal: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Principal Paid on Home Loan", "0", [["required"]]),
        homeLoanInterest: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Interest Paid on Home Loan", "0", [["required"]]),
        lenderName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Name of the Lender", null, [["required"]]),
        lenderPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Lender PAN", null, [["required"], ["pattern", PAN_REGEX_PATTERN]]),
        principalAttachments: getAttachmentConfig(),
        interestAttachments: getAttachmentConfig(),
        principalApprovedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        principalStatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        principalComments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]]),
        interestApprovedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        interestStatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        interestComments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]])
    };

    const initialRentalIncomeState = {
        annualRentReceived: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Annual Rent Received", "0", [["required"]]),
        municipalTaxesPaid: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Municipal Taxes Paid", "0", [["required"]]),
        netAnnualValue: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Net Annual Value", null, [["required"]], null, true),
        standardDeduction: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Standard Deduction (@30% of Net Annual Value)", null, [["required"]], null, true),
        repayingHomeLoan: getDefaultFieldConfig(INPUT_TYPE.CHECKBOX, "Repaying Home Loan for this Property", true, [[]]),
        homeLoanPrincipal: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Principal Paid on Home Loan", "0", [["required"]]),
        homeLoanInterest: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Interest Paid on Home Loan", "0", [["required"]]),
        lenderName: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Name of the Lender", null, [["required"]]),
        lenderPAN: getDefaultFieldConfig(INPUT_TYPE.TEXT, "Lender PAN", null, [["required"], ["pattern", PAN_REGEX_PATTERN]]),
        netIncomeLoss: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Net Income/Loss from House Property", "0", [["required"]], null, true),
        annualRentAttachments: getAttachmentConfig(),
        municipalTaxesAttachments: getAttachmentConfig(),
        principalAttachments: getAttachmentConfig(),
        interestAttachments: getAttachmentConfig(),
        annualRentApprovedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        annualRentStatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        annualRentComments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]]),
        municipalTaxesApprovedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        municipalTaxesStatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        municipalTaxesComments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]]),
        principalApprovedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        principalStatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        principalComments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]]),
        interestApprovedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        interestStatus: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        interestComments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]])
    };

    const initialInvestmentState = {
        investment: getDefaultFieldConfig(INPUT_TYPE.SELECT, "Investment", null, [["required"]]),
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Amount", "0", [["required"]]),
        attachments: getAttachmentConfig(),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        comments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]])
    };

    const initialOtherIncomeSourceState = {
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Income from other sources", "0", [["required"]]),
        attachments: getAttachmentConfig(),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        comments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]])
    };

    const initialSavingDepositInterestState = {
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Interest Earned from Savings Deposit", "0", [["required"]]),
        attachments: getAttachmentConfig(),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        comments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]])
    };

    const initialFixedDepositInterestState = {
        amount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Actual Interest Earned from Fixed Deposit", "0", [["required"]]),
        attachments: getAttachmentConfig(),
        approvedAmount: getDefaultFieldConfig(INPUT_TYPE.NUMBER, "Approved Amount", "-", [[]]),
        status: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, INVESTMENT_STATUS.PENDING, [[]]),
        comments: getDefaultFieldConfig(INPUT_TYPE.TEXT, null, [], [[]])
    };

    const [count, updateCount] = useState(1);
    const [showSection, setShowSection] = useState(false);
    const [POIConfig, setPOIConfig] = useState(null);

    const [financialYear, setFinancialYear] = useState(initialFinancialYearState);
    const [newRegime, setNewRegime] = useState(initialRegimeState);
    const [houseRentEnabled, setHouseRentEnabled] = useState(false);
    const [houseRentState, setHouseRentState] = useState([]);
    const [homeLoanEnabled, setHomeLoanEnabled] = useState(false);
    const [homeLoanState, setHomeLoanState] = useState([]);
    const [rentalIncomeEnabled, setRentalIncomeEnabled] = useState(false);
    const [rentalIncomeState, setRentalIncomeState] = useState([]);
    const [investment80CState, setInvestment80CState] = useState([]);
    const [investment80DState, setInvestment80DState] = useState([]);
    const [otherInvestmentState, setOtherInvestmentState] = useState([]);
    const [otherIncomeState, setOtherIncomeState] = useState([initialOtherIncomeSourceState, initialSavingDepositInterestState, initialFixedDepositInterestState]);

    const [taxDeclarationItems, setTaxDeclarationItems] = useState([]);
    const [investment80CItems, setInvestment80CItems] = useState([]);
    const [investment80DItems, setInvestment80DItems] = useState([]);
    const [otherInvestmentItems, setOtherInvestmentItems] = useState([]);

    const [isEdit, setIsEdit] = useState(false);
    const [POIData, setPOIData] = useState(null);
    const [isLocked, setIsLocked] = useState(null);
    const [taxEstimate, setTaxEstimate] = useState(null);
    const [isRejectedApproval, setIsRejectedApproval] = useState(false);
    const [approvalData, setApprovalData] = useState(null);

    const [address, setAddress] = useState(null);
    const [viewportLarge, setIsViewportLarge] = useState(isViewportLarge());

    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            setIsViewportLarge(isViewportLarge())
        }
        // Add event listener
        window.addEventListener("resize", handleResize);
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const forceUpdate = () => {
        updateCount(count + 1);
    }

    useEffect(() => {
        RouteManager.setPresenter({props: {...props, history: history}});

        if (!userId) {
            RouteManager.navigateToHome();
            return;
        }

        AppManager.scrollToTop();

        setTimeout(() => {
            ReactTooltip.rebuild();
        },1000);

        getPOIConfig();
    }, []);

    useEffect(() => {
        if (isLocked !== null) {
            setShowSection(true);
        }
    }, [isLocked]);

    useEffect(() => {
        if (POIConfig) {
            getITActual();
        }
    }, [POIConfig]);

    useEffect(() => {
        if (financialYear && POIConfig) {
            getITActual();
            resetData();
        }
    }, [financialYear]);

    useEffect(() => {
        if (taxDeclarationItems) {
            separateItemsIntoSections();
        }
    }, [taxDeclarationItems]);

    useEffect(() => {
        if (POIData && investment80CItems && investment80CItems.length > 0) {
            setInvestmentData(setInvestment80CState, POIData.investment80C, investment80CItems, approvalData?.investment80C);
        }
    }, [investment80CItems]);

    useEffect(() => {
        if (POIData && investment80DItems && investment80DItems.length > 0) {
            setInvestmentData(setInvestment80DState, POIData.investment80D, investment80DItems, approvalData?.investment80D);
        }
    }, [investment80DItems]);

    useEffect(() => {
        if (POIData && otherInvestmentItems && otherInvestmentItems.length > 0) {
            setInvestmentData(setOtherInvestmentState, POIData.otherExemptions, otherInvestmentItems, approvalData?.otherExemptions);
        }
    }, [otherInvestmentItems]);

    useEffect(() => {
        if (POIData) {
            getTaxDeclarationItems();

            setNewRegime({newRegime: { ...newRegime.newRegime, value: POIData.newRegime}});
            setHouseRentData(POIData.houseRents, approvalData?.houseRents);
            setHomeLoanData(POIData.homeLoanRepayment, approvalData?.homeLoanRepayment);
            setRentalIncomeData(POIData.rentalIncome, approvalData?.rentalIncome);
            setOtherIncomeData(POIData.otherIncomeSources, approvalData?.otherIncomeSources);
        }
    }, [POIData]);

    useEffect(() => {
        forceUpdate();
    }, [
        houseRentState,
        homeLoanState,
        rentalIncomeState,
        investment80CState,
        investment80DState,
        otherInvestmentState,
        otherIncomeState
    ]);

    const getTaxDeclarationItems = () => {
        INComplianceService.getTaxDeclarationItems().then(
            (response) => {
                removeLoader();
                if (response) {
                    setTaxDeclarationItems(response);
                }
            }, (error) => {
                removeLoader();
            }
        );
    }

    const isRejected = (response) => {
        let isRejected = false;

        const states = [
            response.houseRents,
            response.rentalIncome,
            response.homeLoanRepayment,
            response.investment80C,
            response.investment80D,
            response.otherExemptions,
            response.otherIncomeSources
        ];

        states.forEach((state) => {
            if (state) {
                if (Array.isArray(state)) {
                    state.forEach((s) => {
                        if (Array.isArray(s.amountDetails)) {
                            s.amountDetails.forEach((amount) => {
                                if (amount.status === "REJECTED") {
                                    isRejected = true;
                                }
                            });
                        }
                    });
                } else {
                    if (Array.isArray(state.amountDetails)) {
                        state.amountDetails.forEach((amount) => {
                            if (amount.status === "REJECTED") {
                                isRejected = true;
                            }
                        });
                    }
                }
            }
        });

        return isRejected;
    }

    const setIsLockedState = (isLocked) => {
        if (!isMyPOI && !PermissionUtils.hasAccess(MODULE.EMPLOYEE_POI, [ACTION.DRAFT, ACTION.SUBMIT])) {
            isLocked = true;
        }

        setIsLocked(isLocked);
    }

    const setLockUnlockStatus = (activeConfig, POIDataResponse, approvalDataResponse) => {
        let locked = false;

        if (approvalDataResponse && approvalDataResponse.status === INVESTMENT_STATUS.SUBMITTED) {
            if (isRejected(approvalDataResponse)) {
                setIsRejectedApproval(true);
                locked = false;
            } else {
                locked = true;
                showAlert("Alert", "Not allowed to edit approved Proof of Investments");
            }
        } else if (POIDataResponse.status === INVESTMENT_STATUS.SUBMITTED) {
            locked = true;
            showAlert("Alert", "Not allowed to edit submitted Proof of Investments");
        } else if (activeConfig.proofOfInvestmentLockStatus) {
            locked = true;
            showAlert("Alert", "Time period to submit Proof of Investments is locked");
        } else if (!(moment().startOf("day").isSameOrAfter(moment(activeConfig.proofOfInvestmentStartDate, DATE_FORMAT.YYYYMMDD))
            && moment().startOf("day").isSameOrBefore(moment(activeConfig.proofOfInvestmentEndDate, DATE_FORMAT.YYYYMMDD)))) {
            locked = true;
            showAlert("Alert", "Proof of Investment is locked, Please contact your Admin.");
        } else if (Array.isArray(financialYear.financialYear.value) && currentFinancialYear != financialYear.financialYear.options[financialYear.financialYear.value[0]]) {
            locked = true;
        }

        setIsLockedState(locked);

        return locked;
    }

    const resetData = () => {
        setIsEdit(false);
        setIsLockedState(false);

        setNewRegime(initialRegimeState);
        setHouseRentEnabled(false);
        setHouseRentState([]);
        setHomeLoanEnabled(false);
        setHomeLoanState([]);
        setRentalIncomeEnabled(false);
        setRentalIncomeState([]);
        setInvestment80CState([]);
        setInvestment80DState([]);
        setOtherInvestmentState([]);
        setOtherIncomeState([initialOtherIncomeSourceState, initialSavingDepositInterestState, initialFixedDepositInterestState]);
    }

    const getPOIConfig = () => {
        showLoader();
        INComplianceService.getITDeclarationConfig().then(
            (POIConfigResponse) => {
                removeLoader();
                if (POIConfigResponse && POIConfigResponse.investmentConfig && POIConfigResponse.investmentConfig.proofOfInvestmentConfig) {
                    const proofOfInvestmentConfig = POIConfigResponse.investmentConfig.proofOfInvestmentConfig;
                    const activeConfig = proofOfInvestmentConfig.find(config => config.active && config.proofOfInvestmentStartDate !== "1900-01-01T00:00:00Z" && config.proofOfInvestmentEndDate !== "1900-01-01T00:00:00Z");
                    if (activeConfig) {
                        setPOIConfig(activeConfig);
                    } else {
                        setIsLockedState(true);
                        showAlert("Alert", "Proof of Investment is locked, Please contact your Admin.");
                    }
                } else {
                    setIsLockedState(true);
                    showAlert("Alert", "Proof of Investment is locked, Please contact your Admin.");
                }
            }, (error) => {
                removeLoader();
                setIsLockedState(true);
                showAlert("Alert", "Proof of Investment is locked, Please contact your Admin.");
            }
        );
    }

    const getITActual = () => {
        const params = {
            stage: INVESTMENT_STATUS.ACTUAL,
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD),
            userId: userId
        };
        showLoader();
        INComplianceService.getITDeclaration(params).then(
            (POIDataResponse) => {
                if (POIDataResponse.status === INVESTMENT_STATUS.SUBMITTED) {
                    params.stage = INVESTMENT_STATUS.APPROVED;

                    INComplianceService.getITDeclaration(params).then(
                        (approvalDataResponse) => {
                            removeLoader();
                            if (approvalDataResponse.status === INVESTMENT_STATUS.SUBMITTED) {
                                setApprovalData(approvalDataResponse);
                            }

                            setIsEdit(true);
                            setPOIData(POIDataResponse);
                            setLockUnlockStatus(POIConfig, POIDataResponse, approvalDataResponse);
                        }, (error) => {
                            removeLoader();
                            setIsEdit(true);
                            setPOIData(POIDataResponse);
                            setLockUnlockStatus(POIConfig, POIDataResponse, null);
                        }
                    );
                } else {
                    setIsEdit(true);
                    setPOIData(POIDataResponse);
                    setLockUnlockStatus(POIConfig, POIDataResponse);
                    removeLoader();
                }
            }, (error) => {
                if (!setLockUnlockStatus(POIConfig, error)) {
                    getITDeclaration();
                } else {
                    removeLoader();
                }
            }
        );
    }

    const getITDeclaration = () => {
        const params = {
            stage: INVESTMENT_STATUS.DECLARATION,
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD),
            userId: userId
        };
        INComplianceService.getITDeclaration(params).then(
            (ITDeclarationResponse) => {
                removeLoader();
                if (ITDeclarationResponse && ITDeclarationResponse.status === INVESTMENT_STATUS.SUBMITTED) {
                    setPOIData(ITDeclarationResponse);
                } else {
                    setIsLockedState(true);
                    showAlert("Alert", "Please, first submit the IT Declaration");
                }
            }, (error) => {
                setIsLockedState(true);
                removeLoader();
                showAlert("Alert", "Please, first submit the IT Declaration");
            }
        );
    }

    const separateItemsIntoSections = () => {
        const investment80C = [];
        const investment80D = [];
        const otherInvestment = [];

        taxDeclarationItems.forEach((item) => {
            switch (item.section) {
                case "80C":
                case "80CC":
                case "80CCD(1)":
                    investment80C.push(item.value);
                    break;
                case "80D":
                    investment80D.push(item.value);
                    break;
                default:
                    if (["OTHER_INCOME","HOME_LOAN","HOUSE_RENT","RENTAL_INCOME"].indexOf(item.section) === -1) {
                        otherInvestment.push(item.value);
                    }
            }
        });

        setInvestment80CItems(investment80C);
        setInvestment80DItems(investment80D);
        setOtherInvestmentItems(otherInvestment);
    }

    const setSelectFieldValue = (config, options, searchField, valueField) => {
        let index;
        if (valueField) {
            if (searchField) {
                index = options.findIndex((item) => item[searchField] === valueField);
            } else {
                index = options.findIndex((item) => item === valueField);
            }

            config.value = [index];
        }
    }

    const setAmountValue = (config, amountDetails, taxItemKey, attachments, approvedAmount, status, comments) => {
        if (amountDetails && amountDetails.length > 0) {
            const index = amountDetails.findIndex((amountDetail) => amountDetail.name === taxItemKey);
            if (index !== -1) {
                config.value = amountDetails[index].declaredAmount;
                attachments.files = amountDetails[index].attachments ? amountDetails[index].attachments : [];
            }
        }
    }

    const setApprovalValue = (config, amountDetails, taxItemKey, status, comments) => {
        if (amountDetails && amountDetails.length > 0) {
            const index = amountDetails.findIndex((amountDetail) => amountDetail.name === taxItemKey);
            if (index !== -1) {
                config.value = amountDetails[index].declaredAmount;
                status.value = amountDetails[index].status ? amountDetails[index].status : INVESTMENT_STATUS.PENDING;
                comments.value = amountDetails[index].approverComments ? amountDetails[index].approverComments : [];
            }
        }
    }

    const setHouseRentData = (houseRent, approvedHouseRent) => {
        if (houseRent && houseRent.length > 0) {
            setHouseRentEnabled(true);

            const houseRentState = houseRent.map((rent, index) => {
                let state = deepClone(initialHouseRentState);
                state.rentalFromDate.value = moment(rent.rentalFromDate, DATE_FORMAT.YYYYMMDD).toDate();
                state.rentalToDate.value = moment(rent.rentalToDate, DATE_FORMAT.YYYYMMDD).toDate();
                setAmountValue(state.amount, rent.amountDetails, "HOUSE_RENT", state.amountAttachments);
                state.addressLine1.value = rent.address.addressLine1;
                state.addressLine2.value = rent.address.addressLine2;
                state.zipCode.value = rent.address.zipCode;
                state.city.value = rent.address.city;
                setSelectFieldValue(state.state, IN_STATES, "value", rent.address.state);
                setSelectFieldValue(state.country, Countries, "value", rent.address.country);
                state.landlordName.value = rent.landlordName;
                state.landlordPAN.value = rent.landlordPAN;
                state.isMetroCity.value = rent.isMetroCity;

                if (approvedHouseRent && approvedHouseRent[index]) {
                    setApprovalValue(state.approvedAmount, approvedHouseRent[index].amountDetails, "HOUSE_RENT", state.status, state.comments);
                }

                return state;
            });

            setHouseRentState(houseRentState);

            if (houseRent[0] && houseRent[0].address) {
                setAddress(houseRent[0].address);
            }
        }
    }

    const setHomeLoanData = (homeLoan, approvedHomeLoan) => {
        if (homeLoan && homeLoan.length > 0) {
            setHomeLoanEnabled(true);

            const homeLoanState = homeLoan.map((loan, index) => {
                const state = deepClone(initialHomeLoanState);
                setAmountValue(state.homeLoanPrincipal, loan.amountDetails, "HOME_LOAN_PRINCIPLE", state.principalAttachments);
                setAmountValue(state.homeLoanInterest, loan.amountDetails, "HOME_LOAN_INTEREST", state.interestAttachments);
                state.lenderName.value = loan.lenderName;
                state.lenderPAN.value = loan.lenderPAN;

                if (approvedHomeLoan && approvedHomeLoan[index]) {
                    setApprovalValue(state.principalApprovedAmount, approvedHomeLoan[index].amountDetails, "HOME_LOAN_PRINCIPLE", state.principalStatus, state.principalComments);
                    setApprovalValue(state.interestApprovedAmount, approvedHomeLoan[index].amountDetails, "HOME_LOAN_INTEREST", state.interestStatus, state.interestComments);
                }

                return state;
            });

            setHomeLoanState(homeLoanState);
        }
    }

    const setRentalIncomeData = (rentalIncome, approvedRentalIncome) => {
        if (rentalIncome && rentalIncome.length > 0) {
            setRentalIncomeEnabled(true);

            const rentalIncomeState = rentalIncome.map((rental, index) => {
                const state = deepClone(initialRentalIncomeState);
                setAmountValue(state.annualRentReceived, rental.amountDetails, "ANNUAL_RENT", state.annualRentAttachments);
                setAmountValue(state.municipalTaxesPaid, rental.amountDetails, "MUNICIPAL_TAXES", state.municipalTaxesAttachments);
                state.netAnnualValue.value = parseAmount(state.annualRentReceived.value) - parseAmount(state.municipalTaxesPaid.value);
                state.standardDeduction.value = parseAmount(state.netAnnualValue.value) * 0.3;
                state.repayingHomeLoan.value = rental.repayingHomeLoanForThisProperty;

                if (approvedRentalIncome && approvedRentalIncome[index]) {
                    setApprovalValue(state.annualRentApprovedAmount, approvedRentalIncome[index].amountDetails, "ANNUAL_RENT", state.annualRentStatus, state.annualRentComments);
                    setApprovalValue(state.municipalTaxesApprovedAmount, approvedRentalIncome[index].amountDetails, "MUNICIPAL_TAXES", state.municipalTaxesStatus, state.municipalTaxesComments);
                }

                if (rental.repayingHomeLoanForThisProperty) {
                    setAmountValue(state.homeLoanPrincipal, rental.amountDetails, "PRINCIPLE_PAID_HOME_LOAN", state.principalAttachments);
                    setAmountValue(state.homeLoanInterest, rental.amountDetails, "INTEREST_PAID_HOME_LOAN", state.interestAttachments);
                    state.lenderName.value = rental.lenderName;
                    state.lenderPAN.value = rental.lenderPAN;
                    state.netIncomeLoss.value = parseAmount(state.netAnnualValue.value) - parseAmount(state.standardDeduction.value) - parseAmount(state.homeLoanInterest.value);

                    if (approvedRentalIncome && approvedRentalIncome[index]) {
                        setApprovalValue(state.principalApprovedAmount, approvedRentalIncome[index].amountDetails, "PRINCIPLE_PAID_HOME_LOAN", state.principalStatus, state.principalComments);
                        setApprovalValue(state.interestApprovedAmount, approvedRentalIncome[index].amountDetails, "INTEREST_PAID_HOME_LOAN", state.interestStatus, state.interestComments);
                    }
                } else {
                    clearValidation(state, ["homeLoanPrincipal", "homeLoanInterest", "lenderName","lenderPAN", "netIncomeLoss"]);
                }

                return state;
            });

            setRentalIncomeState(rentalIncomeState);
        }
    }

    const setInvestmentData = (setState, investments, investmentItems, approvedInvestments) => {
        if (investments && investments.amountDetails && investments.amountDetails.length > 0) {
            const investmentState = investments.amountDetails.map((investment) => {
                const state = deepClone(initialInvestmentState);
                const index = taxDeclarationItems.findIndex((item) => item.key === investment.name);
                if (index !== -1) {
                    setSelectFieldValue(state.investment, investmentItems, null, taxDeclarationItems[index].value);
                    setAmountValue(state.amount, investments.amountDetails, investment.name, state.attachments);

                    if (approvedInvestments && approvedInvestments.amountDetails) {
                        setApprovalValue(state.approvedAmount, approvedInvestments.amountDetails, investment.name, state.status, state.comments);
                    }
                }

                return state;
            });

            setState(investmentState);
        }
    }

    const setOtherIncomeData = (otherIncome, approvedOtherIncome) => {
        if (otherIncome && otherIncome.amountDetails && otherIncome.amountDetails.length > 0) {
            const state = deepClone(otherIncomeState);

            setAmountValue(state[0].amount, otherIncome.amountDetails, "INCOME_OTHER_SOURCES", state[0].attachments);
            setAmountValue(state[1].amount, otherIncome.amountDetails, "SAVINGS_DEPOSIT_INTEREST", state[1].attachments);
            setAmountValue(state[2].amount, otherIncome.amountDetails, "FIXED_DEPOSIT_INTEREST", state[2].attachments);

            if (approvedOtherIncome && approvedOtherIncome.amountDetails) {
                setApprovalValue(state[0].approvedAmount, approvedOtherIncome.amountDetails, "INCOME_OTHER_SOURCES", state[0].status, state[0].comments);
                setApprovalValue(state[1].approvedAmount, approvedOtherIncome.amountDetails, "SAVINGS_DEPOSIT_INTEREST", state[1].status, state[1].comments);
                setApprovalValue(state[2].approvedAmount, approvedOtherIncome.amountDetails, "FIXED_DEPOSIT_INTEREST", state[2].status, state[2].comments);
            }

            setOtherIncomeState(state);
        }
    }

    const getSelectFieldValue = (config, options, searchField, valueField) => {
        let actualValue;
        if (searchField && valueField) {
            actualValue = options.find((item) => item[searchField] === config.options[config.value[0]])[valueField];
        } else {
            actualValue = options.find((item) => item === config.options[config.value[0]]);
        }

        return actualValue;
    }

    const getAmountDetails = (amount) => {
        const amountDetails = [];

        for (const [key, value] of Object.entries(amount)) {
            amountDetails.push({
                name: key,
                declaredAmount: parseAmount(value[0]),
                attachments: value[1] ? value[1] : [],
                status: INVESTMENT_STATUS.PENDING
            });
        }

        return amountDetails;
    }

    const getHouseRentData = (houseRent) => {
        const houseRentData = [];

        houseRent.forEach((state) => {
            houseRentData.push({
                rentalFromDate: moment(state.rentalFromDate.value).format(DATE_FORMAT.YYYYMMDD),
                rentalToDate: moment(state.rentalToDate.value).format(DATE_FORMAT.YYYYMMDD),
                address: {
                    addressLine1: state.addressLine1.value,
                    addressLine2: state.addressLine2.value,
                    zipCode: state.zipCode.value,
                    city: state.city.value,
                    state: getSelectFieldValue(state.state, IN_STATES, "label", "value"),
                    country: getSelectFieldValue(state.country, Countries, "label", "value")
                },
                landlordName: state.landlordName.value,
                landlordPAN: state.landlordPAN.value,
                isMetroCity: state.isMetroCity.value,
                amountDetails: getAmountDetails({
                    "HOUSE_RENT": [state.amount.value, state.amountAttachments.files]
                })
            });
        });

        return houseRentData;
    }

    const getHomeLoanData = (homeLoan) => {
        const homeLoanData = [];

        homeLoan.forEach((state) => {
            homeLoanData.push({
                lenderName: state.lenderName.value,
                lenderPAN: state.lenderPAN.value,
                amountDetails: getAmountDetails({
                    "HOME_LOAN_PRINCIPLE": [state.homeLoanPrincipal.value, state.principalAttachments.files],
                    "HOME_LOAN_INTEREST": [state.homeLoanInterest.value, state.interestAttachments.files]
                })
            });
        });

        return homeLoanData;
    }

    const getRentalIncomeData = (rentalIncome) => {
        const rentalIncomeData = [];

        rentalIncome.forEach((state) => {
            const income = {
                netValue: state.netAnnualValue.value,
                deduction: state.standardDeduction.value,
                repayingHomeLoanForThisProperty: state.repayingHomeLoan.value
            }

            if (state.repayingHomeLoan.value) {
                income["lenderName"] = state.lenderName.value;
                income["lenderPAN"] = state.lenderPAN.value;
                income["netProfitLoss"] = state.netIncomeLoss.value;
                income["amountDetails"] = getAmountDetails({
                    "ANNUAL_RENT": [state.annualRentReceived.value, state.annualRentAttachments.files],
                    "MUNICIPAL_TAXES": [state.municipalTaxesPaid.value, state.municipalTaxesAttachments.files],
                    "PRINCIPLE_PAID_HOME_LOAN": [state.homeLoanPrincipal.value, state.principalAttachments.files],
                    "INTEREST_PAID_HOME_LOAN": [state.homeLoanInterest.value, state.interestAttachments.files]
                });
            } else {
                income["amountDetails"] = getAmountDetails({
                    "ANNUAL_RENT": [state.annualRentReceived.value, state.annualRentAttachments.files],
                    "MUNICIPAL_TAXES": [state.municipalTaxesPaid.value, state.municipalTaxesAttachments.files]
                });
            }

            rentalIncomeData.push(income);
        });

        return rentalIncomeData;
    }

    const getInvestmentData = (investments) => {
        const amountDetails = [];

        investments.forEach((state) => {
            if (state.investment.value && state.investment.value.length > 0) {
                const key = getSelectFieldValue(state.investment, taxDeclarationItems, "value", "key");
                const amount = {
                    [key]: [state.amount.value, state.attachments.files]
                }
                amountDetails.push(...getAmountDetails(amount))
            }
        });

        return {
            amountDetails: amountDetails
        }
    }

    const getPayload = () => {
        const payload = {
            userId: userId,
            financialYear: getSelectFieldValue(financialYear.financialYear, financialYears),
            newRegime: newRegime.newRegime.value,
            isHouseRentDetails: houseRentEnabled,
            isHouseRentalRepay: homeLoanEnabled,
            isHouseRentalIncome: rentalIncomeEnabled
        }

        if (houseRentEnabled) {
            payload["houseRents"] = getHouseRentData(houseRentState);
        }

        if (homeLoanEnabled) {
            payload["homeLoanRepayment"] = getHomeLoanData(homeLoanState);
        }

        if (rentalIncomeEnabled) {
            payload["rentalIncome"] = getRentalIncomeData(rentalIncomeState);
        }

        payload["investment80C"] = getInvestmentData(investment80CState);
        payload["investment80D"] = getInvestmentData(investment80DState);
        payload["otherExemptions"] = getInvestmentData(otherInvestmentState);

        payload["otherIncomeSources"] = {
            amountDetails: [
                ...getAmountDetails({"INCOME_OTHER_SOURCES": [otherIncomeState[0].amount.value, otherIncomeState[0].attachments.files]}),
                ...getAmountDetails({"SAVINGS_DEPOSIT_INTEREST": [otherIncomeState[1].amount.value, otherIncomeState[1].attachments.files]}),
                ...getAmountDetails({"FIXED_DEPOSIT_INTEREST": [otherIncomeState[2].amount.value, otherIncomeState[2].attachments.files]})
            ]
        };

        return payload;
    }

    const isInvalidITDeclaration = () => {
        let invalid = false;
        const states = [financialYear, newRegime, investment80CState, investment80DState, otherInvestmentState];

        if (houseRentEnabled) {
            states.push(houseRentState);
        }

        if (homeLoanEnabled) {
            states.push(homeLoanState);
        }

        if (rentalIncomeEnabled) {
            states.push(rentalIncomeState);
        }

        states.forEach((state) => {
            if (isInvalidState(state)) {
                invalid = true;
            }
        });

        return invalid;
    }

    const showConfirmDialog = () => {
        showAlert(
            "Confirm",
            "Please make sure all the details are accurate, you will not be able to edit once submitted. Do you want to proceed?",
            [
                {title: "Yes", className: "bg-app text-white mr-l", onClick: () => save(false)},
                {title: "No", className: "bg-app text-white"}
            ]
        );
    }

    const save = (isDraft) => {
        if (isInvalidITDeclaration()) {
            forceUpdate();
            return;
        }

        const payload = getPayload();

        if (isRejectedApproval) {
            updateApproved();
        }

        const params = {
            stage: INVESTMENT_STATUS.ACTUAL,
            status: isDraft ? INVESTMENT_STATUS.DRAFT : INVESTMENT_STATUS.SUBMITTED,
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD)
        };

        const message = (isEdit ? "Updating" : "Saving") + "... Please wait"
        showLoader(message);
        if (!isEdit) {
            INComplianceService.saveITDeclaration(payload, params).then(
                (response) => {
                    removeLoader();
                    if (response) {
                        setIsEdit(true);

                        if (response.status === INVESTMENT_STATUS.SUBMITTED) {
                            setIsLockedState(true);
                        }

                        if (isDraft) {
                            showToast("Proof of investments saved as a draft.", TOAST_TYPE.SUCCESS);
                        } else {
                            showToast("Proof of investments saved successfully.", TOAST_TYPE.SUCCESS);
                        }
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        } else {
            INComplianceService.updateITDeclaration(payload, params).then(
                (response) => {
                    removeLoader();
                    if (response) {
                        if (response.status === INVESTMENT_STATUS.SUBMITTED) {
                            setIsLockedState(true);
                        }

                        if (isDraft) {
                            showToast("Proof of investments updated as a draft.", TOAST_TYPE.SUCCESS);
                        } else {
                            showToast("Proof of investments updated successfully.", TOAST_TYPE.SUCCESS);
                        }
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        }
    }

    const getApprovalPayload = () => {
        const payload = {...approvalData};

        Object.keys(payload).forEach((key) => {
            const state = payload[key];
            if (state) {
                if (Array.isArray(state)) {
                    state.forEach((s) => {
                        if (Array.isArray(s.amountDetails)) {
                            s.amountDetails.forEach((amount) => {
                                if (amount.status === INVESTMENT_STATUS.REJECTED) {
                                    amount.status = INVESTMENT_STATUS.PENDING;
                                }
                            });
                        }
                    });
                } else {
                    if (Array.isArray(state.amountDetails)) {
                        state.amountDetails.forEach((amount) => {
                            if (amount.status === INVESTMENT_STATUS.REJECTED) {
                                amount.status = INVESTMENT_STATUS.PENDING;
                            }
                        });
                    }
                }
            }
        });

        return payload;
    }

    const updateApproved = () => {
        const payload = getApprovalPayload();

        const params = {
            stage: INVESTMENT_STATUS.APPROVED,
            status: INVESTMENT_STATUS.DRAFT,
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD)
        };

        INComplianceService.updateITDeclaration(payload, params).then();
    }

    const showPatternError = (validation, errorMsg, value) => {
        if (value !== null && value !== undefined && String(value).length !== 0) {
            const pattern = validation.findIndex((v) => v[0] === "pattern") !== -1;

            return pattern && (
                <DKLabel
                    className="fs-s text-red mt-s ml-xs"
                    style={{
                        marginTop: "-19px",
                        marginBottom: "8px"
                    }}
                    text={errorMsg}
                />
            )
        }
    }

    const isRequired = (validation) => {
        return validation.findIndex((v) => v[0] === "required") !== -1;
    }

    const getSetStateFunction = (section) => {
        let setState;

        switch (section) {
            case SECTION.FINANCIAL_YEAR:
                setState = setFinancialYear;
                break;
            case SECTION.REGIME:
                setState = setNewRegime;
                break;
            case SECTION.HOUSE_RENT:
                setState = setHouseRentState;
                break;
            case SECTION.HOME_LOAN:
                setState = setHomeLoanState;
                break;
            case SECTION.RENTAL_INCOME:
                setState = setRentalIncomeState;
                break;
            case SECTION.INVESTMENT_80C:
                setState = setInvestment80CState;
                break;
            case SECTION.INVESTMENT_80D:
                setState = setInvestment80DState;
                break;
            case SECTION.OTHER_INVESTMENT:
                setState = setOtherInvestmentState;
                break;
            case SECTION.OTHER_INCOME:
                setState = setOtherIncomeState;
                break;
        }

        return setState;
    }

    const getField = (section, state, index, property) => {
        const setState = getSetStateFunction(section);

        switch (state[property].type) {
            case INPUT_TYPE.TEXT:
            case INPUT_TYPE.NUMBER:
            case INPUT_TYPE.DATE:
                return (
                    <>
                        <DKInput
                            title={state[property].name}
                            type={state[property].type}
                            className="pb-xl"
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            value={state[property].value}
                            errorMessage={state[property].errorMsg}
                            readOnly={!!state[property].readOnly || isLocked || isRejectedApproval}
                            required={isRequired(state[property].validation)}
                            invalid={state[property].invalid}
                            canValidate={state[property].invalid}
                            onChange={(value) => {
                                updateState(section, setState, state, index, property, value);
                            }}
                        />
                        {state[property].invalid && showPatternError(state[property].validation, state[property].errorMsg, state[property].value)}
                    </>
                );
            case INPUT_TYPE.SELECT:
                return (
                    <>
                        <DKInput
                            title={state[property].name}
                            type={state[property].type}
                            className="pb-xl"
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={state[property].options}
                            value={state[property].value}
                            errorMessage={state[property].errorMsg}
                            readOnly={!!state[property].readOnly || isLocked || isRejectedApproval}
                            required={isRequired(state[property].validation)}
                            invalid={state[property].invalid}
                            canValidate={state[property].invalid}
                            onChange={(value) => {
                                updateState(section, setState, state, index, property, value);
                            }}
                        />
                    </>
                )
            case INPUT_TYPE.DROPDOWN:
                return (
                    <DKInput
                        title={state[property].name}
                        type={state[property].type}
                        className="pb-xl"
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        dropdownConfig={{
                            allowSearch: state[property].options?.length > 7,
                            data: state[property].options,
                            renderer: (i, item) => item,
                            onSelect: (i, value) => {
                                updateState(section, setState, state, index, property, [i]);
                            }
                        }}
                        value={getSelectFieldValue(state[property], state[property].options)}
                        errorMessage={state[property].errorMsg}
                        readOnly={property === "financialYear" ? false : (!!state[property].readOnly || isLocked)}
                        required={isRequired(state[property].validation)}
                        invalid={state[property].invalid}
                        canValidate={state[property].invalid}
                        onChange={() => { }}
                    />
                )
            case INPUT_TYPE.CHECKBOX:
                return (
                    <div className="row" style={{ pointerEvents: state[property].readOnly || isLocked || isRejectedApproval ? "none" : "initial" }}>
                        <DKCheckMark
                            className="pt-s pb-l"
                            isSelected={state[property].value}
                            onClick={() => {
                                updateState(section, setState, state, index, property, !state[property].value);
                            }}
                        />
                        <DKLabel className="pt-s pb-l" text={state[property].name} />
                    </div>
                )
            case "radio":
                return (
                    <div className="row" style={{ pointerEvents: state[property].readOnly || isLocked || isRejectedApproval ? "none" : "initial" }}>
                        {state[property].options.map((o) => {
                            return (
                                <div key={o.value} className="row" style={{ width: "auto" }}>
                                    <input
                                        type="radio"
                                        name={property}
                                        style={{ margin: "0", marginRight: "5px" }}
                                        value={o.value}
                                        checked={o.value === state[property].value}
                                        onChange={() => {
                                            updateState(section, setState, state, index, property, o.value);
                                        }}
                                    />
                                    <DKLabel className="mr-l" text={o.name} />
                                </div>
                            )
                        })}
                    </div>
                )
        }
    }

    const getActualAmountField = (section, state, index, property, statusProperty) => {
        const setState = getSetStateFunction(section);

        return (
            <DKInput
                title={state[property].name}
                type={state[property].type}
                className="pb-xl"
                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                value={state[property].value}
                errorMessage={state[property].errorMsg}
                readOnly={state[statusProperty].value === INVESTMENT_STATUS.APPROVED}
                required={isRequired(state[property].validation)}
                invalid={state[property].invalid}
                canValidate={state[property].invalid}
                onChange={(value) => {
                    updateState(section, setState, state, index, property, value);
                }}
            />
        );
    }

    const getApprovedAmountField = (state, property, statusProperty) => {
        return (
            <div className="pb-xxl">
                <DKLabel className="p-v-s" text={state[property].name} />
                <DKLabel text={state[statusProperty].value === INVESTMENT_STATUS.APPROVED ? FormatCurrencyService.format(state[property].value) : "-"} />
            </div>
        )
    }

    const getStatusTag = (state, property, commentProperty) => {
        return (
            <div className="row p-v-l">
                {state[property].value === INVESTMENT_STATUS.APPROVED &&
                    <div className="border-radius-l data-grid-badge-color-6 text-green" style={{padding: "6px 12px"}}>
                        Approved
                    </div>
                }

                {state[property].value === INVESTMENT_STATUS.REJECTED &&
                    <div className="row">
                        <div className="border-radius-l data-grid-badge-color-4 text-red" style={{padding: "6px 12px"}}>
                            Rejected
                        </div>
                        {state[commentProperty].value && state[commentProperty].value.length > 0 && state[commentProperty].value[0] !== "" &&
                            <>
                                <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                                <span data-tip={getRejectionComments(state[commentProperty].value)}>
                                    <DKIcon src={ic_info_warning} className="ic-s ml-xs" />
                                </span>
                            </>
                        }
                    </div>
                }
            </div>
        )
    }

    const getRejectionComments = (comments) => {
        return (
            `<div>
                <div class="fw-m mb-xs">Comments:</div>
                ${comments.map((c, i) => `<div>${i+1}. ${c}</div>`).join('')}
            </div>`
        );
    }

    const getFilename = (url) => {
        return url.substring(url.indexOf("_") + 1, url.length);
    }

    const downloadAttachment = (url) => {
        showLoader("Downloading attachment... Please wait");
        AttachmentService.getPresignedURL(url).then(
            (response) => {
                AttachmentService.downloadFile(response).then(
                    (response) => {
                        removeLoader();
                        saveAs(response, getFilename(url));
                    }, (error) => {
                        removeLoader();
                    }
                )
            }, (error) => {
                removeLoader();
            }
        )
    }

    const uploadAttachments = (setState, state, index, property, files) => {
        if (files && files.length > 0) {
            showLoader("Uploading files... Please wait");
            Promise.all(files.map(f => AttachmentService.getUploadFileURL(f.fileContent, Entity.PEOPLE_DOCUMENT))).then(
                (responses) => {
                    removeLoader();
                    const urls = [...responses].map(response => response.relativePath);
                    if (urls && urls.length > 0) {
                        updateAttachmentState(setState, state, index, property, {show: false, files: [...state[property].files, ...urls]});
                    }
                }, (error) => {
                    if (error?.status === 500 && error?.message?.includes("CONTENT_TYPE_NOT_ALLOWED")) {
                        showAlert(i18next.t('FAIL_TO_UPLOAD'), i18next.t('FILE_FORMAT_TYPE_ERROR_MSG'));
                    } else {
                        showToast(i18next.t('SOMETHING_WENT_WRONG'), TOAST_TYPE.FAILURE)
                    }
                    updateAttachmentState(setState, state, index, property, {show: false});
                    removeLoader();
                }
            );
        }
    }

    const getAttachmentField = (section, state, index, property, statusProperty) => {
        const setState = getSetStateFunction(section);

        return (
            <div className="pb-m">
                <DKLabel className="p-v-s" text={"Attachments"} />
                <div className="row align-items-start pt-xs">
                    {state[property].files && state[property].files.map((url, i) => {
                        return (
                            <>
                                {url && <div key={url} className="column align-items-center mr-s">
                                    <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                                    <span data-tip={getFilename(url)}>
                                        <DKIcon
                                            className="ic-s cursor-hand"
                                            src={ic_document}
                                            onClick={() => {
                                                downloadAttachment(url);
                                            }}
                                        />
                                    </span>
                                    {state[statusProperty].value !== INVESTMENT_STATUS.APPROVED && <span data-tip={"Remove"}>
                                        <DKIcon
                                            className="ic-xs cursor-hand"
                                            src={ic_close}
                                            onClick={() => {
                                                removeAttachment(setState, state, index, property, i);
                                            }}
                                        />
                                    </span>}
                                </div>}
                            </>
                        )
                    })}
                    <ReactTooltip type="dark" place="right" html={true} effect='solid' />
                    {state[statusProperty].value !== INVESTMENT_STATUS.APPROVED && <span data-tip={"Add Attachments"}>
                        <DKIcon
                            className="ic-s cursor-hand pb-l"
                            src={ic_attachment}
                            onClick={() => {
                                updateAttachmentState(setState, state, index, property, {show: true});
                            }}
                        />
                    </span>}
                    {state[property].show && <FileUpload
                        onSave={(files) => {
                            uploadAttachments(setState, state, index, property, files);
                        }}
                        onClose={() => {
                            updateAttachmentState(setState, state, index, property, {show: false});
                        }}
                    />}
                </div>
            </div>
        )
    }

    const getAddStateButton = (title, section, setState, newState, prevState) => {
        return (
            <div className={`${getDisableCSSClass("row mt-l", true)} ${isRejectedApproval ? "pointer-events-none" : ""}`}>
                <DKButton
                    title={title}
                    className={`text-white ${isLocked || isRejectedApproval ? "bg-gray5" : "dk-bg-button"}`}
                    onClick={() => {
                        pushState(section, setState, newState, prevState);
                    }}
                />
            </div>
        )
    }

    const getEnableStateButton = (title, setState, state) => {
        return (
            <div className={`row ${isRejectedApproval ? "pointer-events-none" : ""}`}>
                <Toggle
                    className={getDisableCSSClass("mr-l", true)}
                    style={{width:'25%'}}
                    isOn={state}
                    color={isLocked || isRejectedApproval ? "bg-gray4" : null}
                    onChange={() => {
                        setState(prevState => !prevState)
                    }}
                />
                <DKLabel style={{width:'75%'}} className="mb-xs" text={title} />
            </div>
        )
    }

    const getRemoveStateButton = (setState, index) => {
        return (
            <div>
                {!isRejectedApproval && <DKIcon
                    className="ic-s-2 cursor-hand p-v-l"
                    src={ic_delete}
                    onClick={() => {
                        popState(setState, index);
                    }}
                />}
            </div>
        )
    }

    const enrichConfig = (state, property, extraConfig) => {
        state[property] = {...state[property], ...extraConfig};
        return state;
    }

    const isInvalidState = (state) => {
        let invalid = false;

        if (state) {
            if (Array.isArray(state)) {
                state.forEach((s) => {
                    for (const [key, fieldConfig] of Object.entries(s)) {
                        const error = hasError(fieldConfig.name, fieldConfig.value, fieldConfig.validation, fieldConfig.type);
                        s[key] = {...fieldConfig, ...error};
                        if (error.invalid) {
                            invalid = true;
                        }
                    }
                });
            } else {
                for (const [key, fieldConfig] of Object.entries(state)) {
                    const error = hasError(fieldConfig.name, fieldConfig.value, fieldConfig.validation, fieldConfig.type);
                    state[key] = {...fieldConfig, ...error};
                    if (error.invalid) {
                        invalid = true;
                    }
                }
            }
        }

        return invalid;
    }

    const pushState = (section, setState, newState, prevState) => {
        if (!isInvalidState(prevState)) {
            if (section === SECTION.HOUSE_RENT) {
                newState.rentalFromDate.value = getFinancialYearStartDate().toDate();
                newState.rentalToDate.value = getFinancialYearEndDate().toDate();

                if (address) {
                    newState.addressLine1.value = address.addressLine1;
                    newState.addressLine2.value = address.addressLine2;
                    newState.city.value = address.city;
                    newState.zipCode.value = address.zipCode;
                    newState.isMetroCity.value = (METRO_CITIES.indexOf(address.zipCode.substring(0, 3)) !== -1);
                    setSelectFieldValue(newState.state, IN_STATES, "value", address.state);
                    setSelectFieldValue(newState.country, Countries, "value", address.country);
                }
            }

            setState([...prevState, newState]);
        }

        forceUpdate();
    }

    const popState = (setState, index) => {
        setState((prevState) => {
            return index !== -1 ? prevState.filter((s, i) => i !== index) : [];
        });
    }

    const updateState = (section, setState, state, index, property, value) => {
        if (property === "financialYear") {
            setState((prevState) => {
                if (Array.isArray(prevState[property].value) && Array.isArray(value) && prevState[property].value[0] !== value[0]) {
                    const newConfig = {
                        ...state[property],
                        value: value,
                        ...hasError(state[property].name, value, state[property].validation, state[property].type)
                    };

                    return {...state, [property]: newConfig};
                }

                return prevState;
            });
        } else {
            setState((prevState) => {
                const newConfig = {
                    ...state[property],
                    value: value,
                    ...hasError(state[property].name, value, state[property].validation, state[property].type)
                };

                let newState;
                if (index === -1) {
                    newState = {...state, [property]: newConfig}
                } else {
                    newState = [...prevState];
                    newState[index] = {...state, [property]: newConfig};
                }

                if (section === SECTION.RENTAL_INCOME || section === SECTION.HOUSE_RENT) {
                    updateDependantFields(section, newState, index, property);
                }

                if (property === "investment" && (section === SECTION.INVESTMENT_80C || section === SECTION.INVESTMENT_80D || section === SECTION.OTHER_INVESTMENT)) {
                    if (isDuplicateState(prevState, property, value)) {
                        newState[index] = {...state, [property]: { ...state[property], value: null, invalid: true, errorMsg: "Investment is already selected, please select different" }};
                    }
                }

                return newState;
            });
        }
    }

    const isDuplicateState = (prevState, property, value) => {
        return prevState.findIndex((state) => {
            return Array.isArray(state[property].value) && Array.isArray(value) && state[property].value[0] === value[0]
        }) !== -1;
    }

    const updateAttachmentState = (setState, state, index, property, newConfig) => {
        setState((prevState) => {
            let newState;
            if (index === -1) {
                newState = {...state, [property]: {...state[property], ...newConfig}}
            } else {
                newState = [...prevState];
                newState[index] = {...state, [property]: {...state[property], ...newConfig}};
            }

            return newState;
        });
    }

    const removeAttachment = (setState, state, index, property, removeIndex) => {
        const newConfig = {
            ...state[property],
            files: state[property].files.filter((f, i) => i !== removeIndex)
        }

        updateAttachmentState(setState, state, index, property, newConfig);
    }

    const updateDependantFields = (section, newState, index, property) => {
        const state = newState[index];

        if (section === SECTION.RENTAL_INCOME) {
            if (property === "annualRentReceived" || property === "municipalTaxesPaid") {
                if (state["annualRentReceived"].value && state["municipalTaxesPaid"].value) {
                    updateField(state["netAnnualValue"], (parseAmount(state["annualRentReceived"].value) - parseAmount(state["municipalTaxesPaid"].value)));
                    updateField(state["standardDeduction"], (0.3 * (parseAmount(state["annualRentReceived"].value) - parseAmount(state["municipalTaxesPaid"].value))));
                } else {
                    updateField(state["netAnnualValue"], "");
                    updateField(state["standardDeduction"], "");
                }
            }

            if (state["repayingHomeLoan"].value && state["netAnnualValue"].value && state["standardDeduction"].value && state["homeLoanInterest"].value) {
                updateField(state["netIncomeLoss"], (parseAmount(state["netAnnualValue"].value) - parseAmount(state["standardDeduction"].value) - parseAmount(state["homeLoanInterest"].value)));
            } else {
                updateField(state["netIncomeLoss"], "");
            }

            if (property === "repayingHomeLoan") {
                if (!state["repayingHomeLoan"].value) {
                    clearValidation(state, ["homeLoanPrincipal", "homeLoanInterest", "lenderName","lenderPAN", "netIncomeLoss"]);
                } else {
                    setValidation(initialRentalIncomeState, state, ["homeLoanPrincipal", "homeLoanInterest", "lenderName","lenderPAN", "netIncomeLoss"]);
                }
            }
        }

        if (section === SECTION.HOUSE_RENT) {
            if (property === "zipCode") {
                if (state["zipCode"].value && state["zipCode"].value.length === 6) {
                    updateField(state["isMetroCity"], (METRO_CITIES.indexOf(state["zipCode"].value.substring(0, 3)) !== -1))
                } else {
                    updateField(state["isMetroCity"], false);
                }
            }

            if (property === "amount") {
                if (parseAmount(state["amount"].value) > 100000) {
                    state["landlordPAN"].validation = [["required"], ["pattern", PAN_REGEX_PATTERN]];
                } else {
                    state["landlordPAN"].validation = [["pattern", PAN_REGEX_PATTERN]]
                }
            }

            if ((property === "rentalFromDate" || property === "rentalToDate") && state["rentalFromDate"].value && state["rentalToDate"].value) {
                if (!moment(state["rentalFromDate"].value).isSameOrBefore(moment(state["rentalToDate"].value))) {
                    state[property].value = null;
                    state[property].invalid = true;
                    state[property].errorMsg = property === "rentalFromDate" ? "From date cannot be greater than To date" : "To date cannot be less than From date";
                }
                if (moment(state["rentalFromDate"].value).isBefore(getFinancialYearStartDate()) || moment(state["rentalFromDate"].value).isAfter(getFinancialYearEndDate())){
                    state[property].value = null;
                    state[property].invalid = true;
                    state[property].errorMsg = "Invalid From date";    
                }
                if (moment(state["rentalToDate"].value).isAfter(getFinancialYearEndDate()) || moment(state["rentalFromDate"].value).isBefore(getFinancialYearStartDate())){
                    state[property].value = null;
                    state[property].invalid = true;
                    state[property].errorMsg = "Invalid To date";    
                }
            }
        }
    }

    const updateField = (config, value) => {
        config["value"] = value;
        config["invalid"] = false;
        config["errorMsg"] = null;
    }

    const clearValidation = (state, fields) => {
        if (fields && fields.length > 0) {
            fields.forEach((field) => {
                state[field]["validation"] = [[]];
                state[field]["invalid"] = false;
                state[field]["errorMsg"] = null;
            });
        }
    }

    const setValidation = (initialState, state, fields) => {
        if (fields && fields.length > 0) {
            fields.forEach((field) => {
                state[field]["validation"] = initialState[field]["validation"];
                state[field]["invalid"] = false;
                state[field]["errorMsg"] = null;
            });
        }
    }

    const parseAmount = (number) => {
        return !isNaN(parseFloat(number)) ? parseFloat(number) : 0;
    }

    const hasError = (fieldName, value, validation, type) => {
        let error = {
            invalid: false,
            errorMsg: null
        };

        switch (type) {
            case INPUT_TYPE.SELECT:
                if (value && value.length === 0) {
                    value = null;
                }
                break;
        }

        if (validation && validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                            error.errorMsg = fieldName + " is required";
                        }
                        break;
                    case "pattern":
                        if (value && !new RegExp(validation[1]).test(value)) {
                            error.invalid = true;
                            error.errorMsg = "Invalid " + fieldName;
                        }
                        break;
                }
            });
        }

        return error;
    }

    const getDisableCSSClass = (initial, isButton) => {
        let CSSClass = initial || "";

        if (isLocked) {
            CSSClass += isButton ? " disable-button" : " disable-section";
        }

        return CSSClass;
    }

    const getFinancialYearAndTaxRegime = () => {
        return (
            <div>
                <div style={{ width: "200px" }}>
                    {getField(SECTION.FINANCIAL_YEAR, financialYear, -1, "financialYear")}
                </div>
                <div className={getDisableCSSClass("pb-xl", false)}>
                    {getField(SECTION.REGIME, newRegime, -1, "newRegime")}
                </div>
            </div>
        );
    }

    const getHouseRentDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row align-items-start mt-l">
                    <div className="row align-items-start" style={{ width: width, marginRight: marginRight }}>
                        <div style={{ width: "45%", marginRight: marginRight }}>
                            {getField(section, state, index, "rentalFromDate")}
                        </div>
                        <div style={{ width: "45%" }}>
                            {getField(section, state, index, "rentalToDate")}
                        </div>
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {!isRejectedApproval && getField(section, state, index, "amount")}
                            {isRejectedApproval && getActualAmountField(section, state, index, "amount", "status")}
                        </div>
                    </div>
                    <div style={{ width: "15%", marginRight: marginRight }}>
                        <div>
                            {getAttachmentField(section, state, index, "amountAttachments", "status")}
                        </div>
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getApprovedAmountField(state, "approvedAmount", "status")}
                        </div>
                    </div>
                    <div style={{ width: "15%", marginRight: marginRight }}>
                        <div>
                            {getStatusTag(state, "status", "comments")}
                        </div>
                    </div>
                    {getRemoveStateButton(setHouseRentState, index)}
                </div>
                <div className="row">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "addressLine1")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "addressLine2")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "zipCode")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "city")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "state")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "country")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getField(section, state, index, "landlordName")}
                        </div>
                    </div>
                    <div style={{ width: width }}>
                        <div>
                            {getField(section, state, index, "landlordPAN")}
                        </div>
                    </div>
                </div>
                <div className="row">
                    {getField(section, state, index, "isMetroCity")}
                </div>
            </div>
        );
    }

    const getHouseRentDetailsSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"House Rent Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {getEnableStateButton("Employee stays in a rented house", setHouseRentEnabled, houseRentEnabled)}
                    {houseRentEnabled && houseRentState.map((houseRent, index) => getHouseRentDetails(SECTION.HOUSE_RENT, houseRent, index))}
                    {houseRentEnabled && getAddStateButton("+ HOUSE RENT", SECTION.HOUSE_RENT, setHouseRentState, initialHouseRentState, houseRentState)}
                </div>
            </div>
        );
    }

    const getHomeLoanDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row align-items-start mt-l">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {!isRejectedApproval && getField(section, state, index, "homeLoanPrincipal")}
                            {isRejectedApproval && getActualAmountField(section, state, index, "homeLoanPrincipal", "principalStatus")}
                        </div>
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getAttachmentField(section, state, index, "principalAttachments", "principalStatus")}
                        </div>
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getApprovedAmountField(state, "principalApprovedAmount", "principalStatus")}
                        </div>
                    </div>
                    <div style={{ width: "15%", marginRight: marginRight }}>
                        <div>
                            {getStatusTag(state, "principalStatus", "principalComments")}
                        </div>
                    </div>
                    {getRemoveStateButton(setHomeLoanState, index)}
                </div>
                <div className="row align-items-start">
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {!isRejectedApproval && getField(section, state, index, "homeLoanInterest")}
                            {isRejectedApproval && getActualAmountField(section, state, index, "homeLoanInterest", "interestStatus")}
                        </div>
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getAttachmentField(section, state, index, "interestAttachments", "interestStatus")}
                        </div>
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getApprovedAmountField(state, "interestApprovedAmount", "interestStatus")}
                        </div>
                    </div>
                    <div style={{ width: "15%", marginRight: marginRight }}>
                        <div>
                            {getStatusTag(state, "interestStatus", "interestComments")}
                        </div>
                    </div>
                </div>
                <div style={{ width: width }}>
                    <div>
                        {getField(section, state, index, "lenderName")}
                    </div>
                    <div>
                        {getField(section, state, index, "lenderPAN")}
                    </div>
                </div>
            </div>
        );
    }

    const getHomeLoanSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Home Loan Repayment Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {getEnableStateButton("Employee is repaying home loan for a self occupied house property", setHomeLoanEnabled, homeLoanEnabled)}
                    {homeLoanEnabled && homeLoanState.map((homeLoan, index) => getHomeLoanDetails(SECTION.HOME_LOAN, homeLoan, index))}
                    {homeLoanEnabled && getAddStateButton("+ HOME LOAN REPAYMENT", SECTION.HOME_LOAN, setHomeLoanState, initialHomeLoanState, homeLoanState)}
                </div>
            </div>
        )
    }

    const getRentalIncomeDetails = (section, state, index) => {
        return (
            <div key={index}>
                {index !== 0 && <DKLine className="bg-gray3" />}
                <div className="row align-items-start mt-l">
                    <div style={{ width: width, marginRight: marginRight }}>
                        {!isRejectedApproval && getField(section, state, index, "annualRentReceived")}
                        {isRejectedApproval && getActualAmountField(section, state, index, "annualRentReceived", "annualRentStatus")}
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getAttachmentField(section, state, index, "annualRentAttachments", "annualRentStatus")}
                        </div>
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getApprovedAmountField(state, "annualRentApprovedAmount", "annualRentStatus")}
                        </div>
                    </div>
                    <div style={{ width: "15%", marginRight: marginRight }}>
                        <div>
                            {getStatusTag(state, "annualRentStatus", "annualRentComments")}
                        </div>
                    </div>
                    {getRemoveStateButton(setRentalIncomeState, index)}
                </div>
                <div className="row align-items-start">
                    <div style={{ width: width, marginRight: marginRight }}>
                        {!isRejectedApproval && getField(section, state, index, "municipalTaxesPaid")}
                        {isRejectedApproval && getActualAmountField(section, state, index, "municipalTaxesPaid", "municipalTaxesStatus")}
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getAttachmentField(section, state, index, "municipalTaxesAttachments", "municipalTaxesStatus")}
                        </div>
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getApprovedAmountField(state, "municipalTaxesApprovedAmount", "municipalTaxesStatus")}
                        </div>
                    </div>
                    <div style={{ width: "15%", marginRight: marginRight }}>
                        <div>
                            {getStatusTag(state, "municipalTaxesStatus", "municipalTaxesComments")}
                        </div>
                    </div>
                </div>
                <div style={{ width: width }}>
                    <div>
                        {getField(section, state, index, "netAnnualValue")}
                    </div>
                    <div>
                        {getField(section, state, index, "standardDeduction")}
                    </div>
                    <div className="row">
                        {getField(section, state, index, "repayingHomeLoan")}
                    </div>
                </div>
                {state.repayingHomeLoan.value &&
                    <>
                        <div className="row align-items-start">
                            <div style={{ width: width, marginRight: marginRight }}>
                                {!isRejectedApproval && getField(section, state, index, "homeLoanPrincipal")}
                                {isRejectedApproval && getActualAmountField(section, state, index, "homeLoanPrincipal", "principalStatus")}
                            </div>
                            <div style={{ width: width, marginRight: marginRight }}>
                                <div>
                                    {getAttachmentField(section, state, index, "principalAttachments", "principalStatus")}
                                </div>
                            </div>
                            <div style={{ width: width, marginRight: marginRight }}>
                                <div>
                                    {getApprovedAmountField(state, "principalApprovedAmount", "principalStatus")}
                                </div>
                            </div>
                            <div style={{ width: "15%", marginRight: marginRight }}>
                                <div>
                                    {getStatusTag(state, "principalStatus", "principalComments")}
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-start">
                            <div style={{ width: width, marginRight: marginRight }}>
                                {!isRejectedApproval && getField(section, state, index, "homeLoanInterest")}
                                {isRejectedApproval && getActualAmountField(section, state, index, "homeLoanInterest", "interestStatus")}
                            </div>
                            <div style={{ width: width, marginRight: marginRight }}>
                                <div>
                                    {getAttachmentField(section, state, index, "interestAttachments", "interestStatus")}
                                </div>
                            </div>
                            <div style={{ width: width, marginRight: marginRight }}>
                                <div>
                                    {getApprovedAmountField(state, "interestApprovedAmount", "interestStatus")}
                                </div>
                            </div>
                            <div style={{ width: "15%", marginRight: marginRight }}>
                                <div>
                                    {getStatusTag(state, "interestStatus", "interestComments")}
                                </div>
                            </div>
                        </div>
                        <div style={{ width: width }}>
                            <div>
                                {getField(section, state, index, "lenderName")}
                            </div>
                            <div>
                                {getField(section, state, index, "lenderPAN")}
                            </div>
                            <div>
                                {getField(section, state, index, "netIncomeLoss")}
                            </div>
                        </div>
                    </>
                }
            </div>
        );
    }

    const getRentalIncomeSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Rental Income Details"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {getEnableStateButton("Employee is receiving rental income let out property", setRentalIncomeEnabled, rentalIncomeEnabled)}
                    {rentalIncomeEnabled && rentalIncomeState.map((rentalIncome, index) => getRentalIncomeDetails(SECTION.RENTAL_INCOME, rentalIncome, index))}
                    {rentalIncomeEnabled && getAddStateButton("+ LET OUT PROPERTY", SECTION.RENTAL_INCOME, setRentalIncomeState, initialRentalIncomeState, rentalIncomeState)}
                </div>
            </div>
        );
    }

    const getInvestmentDetails = (section, setState, state, index, options) => {
        return (
            <div key={index}>
                <div className="row align-items-start mt-l">
                    <div style={{ width: width }}>
                        {getField(section, enrichConfig(state, "investment", {options: options}), index, "investment")}
                    </div>
                    <div className="ml-xxl" style={{ width: width, marginRight: marginRight }}>
                        {!isRejectedApproval && getField(section, state, index, "amount")}
                        {isRejectedApproval && getActualAmountField(section, state, index, "amount", "status")}
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        {getAttachmentField(section, state, index, "attachments", "status")}
                    </div>
                    <div style={{ width: width, marginRight: marginRight }}>
                        <div>
                            {getApprovedAmountField(state, "approvedAmount", "status")}
                        </div>
                    </div>
                    <div style={{ width: "15%", marginRight: marginRight }}>
                        <div>
                            {getStatusTag(state, "status", "comments")}
                        </div>
                    </div>
                    {getRemoveStateButton(setState, index)}
                </div>
            </div>
        );
    }

    const get80CInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"80C Investments"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                        <DKIcon className="ic-s mr-s" src={ic_info_warning} />
                        <DKLabel className="fw-m text-gray" text={"This section contains the list of investments including LIC schemes, mutual funds and PPF. The maximum limit for this section is ₹150,000.00"} />
                    </div>
                    {showSection && investment80CState.map((investment, index) => getInvestmentDetails(SECTION.INVESTMENT_80C, setInvestment80CState, investment, index, investment80CItems))}
                    {getAddStateButton("+ 80C INVESTMENT", SECTION.INVESTMENT_80C, setInvestment80CState, initialInvestmentState, investment80CState)}
                </div>
            </div>
        );
    }

    const get80DInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"80D Investments"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                        <DKIcon className="ic-s mr-s" src={ic_info_warning} />
                        <DKLabel className="fw-m text-gray" text={"This section contains Mediclaim policies for yourself, your children, spouse and parents. The maximum limit for this section is ₹100,000.00"} />
                    </div>
                    {showSection && investment80DState.map((investment, index) => getInvestmentDetails(SECTION.INVESTMENT_80D, setInvestment80DState, investment, index, investment80DItems))}
                    {getAddStateButton("+ 80D INVESTMENT", SECTION.INVESTMENT_80D, setInvestment80DState, initialInvestmentState, investment80DState)}
                </div>
            </div>
        );
    }

    const getOtherInvestmentSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Other Investments & Exemptions"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    <div className="row">
                        <DKIcon className="ic-s mr-s" src={ic_info_warning} />
                        <DKLabel className="fw-m text-gray" text={"Declare other investments & exemptions such as Voluntary NPS, Interest Paid on Education Loan and Medical Expenditures under this section."} />
                    </div>
                    {showSection && otherInvestmentState.map((investment, index) => getInvestmentDetails(SECTION.OTHER_INVESTMENT, setOtherInvestmentState, investment, index, otherInvestmentItems))}
                    {getAddStateButton("+ INVESTMENT", SECTION.OTHER_INVESTMENT, setOtherInvestmentState, initialInvestmentState, otherInvestmentState)}
                </div>
            </div>
        );
    }

    const getOtherIncomeDetails = (section, state, index) => {
        return (
            <div key={index} className="row row-responsive align-items-start">
                <div style={{ width: viewportLarge ? "25%" : "100%", marginRight: marginRight }}>
                    {!isRejectedApproval && getField(section, state, index, "amount")}
                    {isRejectedApproval && getActualAmountField(section, state, index, "amount", "status")}
                </div>
                <div style={{ width: viewportLarge ? width : "100%", marginRight: marginRight }}>
                    {getAttachmentField(section, state, index, "attachments", "status")}
                </div>
                <div style={{ width: viewportLarge ? width : "100%", marginRight: marginRight }}>
                    {getApprovedAmountField(state, "approvedAmount", "status")}
                </div>
                <div style={{ width: viewportLarge ? "15%" : "100%" }}>
                    {getStatusTag(state, "status", "comments")}
                </div>
                <DKLine className="bg-gray2 m-v-r display-only-mobile" />
            </div>
        )
    }

    const getOtherIncomeSection = () => {
        return (
            <div className={getDisableCSSClass("bg-white border-radius-s shadow-s mt-l", false)}>
                <DKLabel className="fs-l fw-m p-xl" text={"Other Sources of Income"} />
                <div className="border-s"></div>
                <div className="p-xl text-align-left">
                    {showSection && otherIncomeState.map((otherIncome, index) => getOtherIncomeDetails(SECTION.OTHER_INCOME, otherIncome, index))}
                </div>
            </div>
        );
    }

    const getIincomeTaxCalculationPopup = () => {
        return (
            <div className="transparent-background">
                <div className="popup-window" style={{ padding: 24, maxWidth: "600px" }}>
                    <div className="popup-wrapper parent-width parent-height">
                        <DKLabel className="fs-xl fw-m" text={"Income Tax Calculated"} />
                        <DKLabel className="fs-m" text={"You can select amount the Old Tax Regime and New Tax Regime."} />
                        <div className="row mt-xxl mb-s">
                            <div
                                className={`p-l cursor-hand border-m border-radius-s ${taxEstimate.newRegime === false ? "border-green" : ""}`}
                                style={{
                                    width: "48%",
                                    marginRight: "4%"
                                }}
                                onClick={() => {
                                    setTaxEstimate({
                                        ...taxEstimate,
                                        newRegime: false
                                    });
                                }}
                            >
                                <DKLabel className="fs-r fw-m" text={"Old Tax Regime"} />
                                <DKLabel className="fs-xl fw-m" text={`Tax Liability: ${taxEstimate.amountOldRegime}`} />
                            </div>
                            <div
                                className={`p-l cursor-hand border-m border-radius-s ${taxEstimate.newRegime === true ? "border-green" : ""}`}
                                style={{ width: "48%" }}
                                onClick={() => {
                                    setTaxEstimate({
                                        ...taxEstimate,
                                        newRegime: true
                                    });
                                }}
                            >
                                <DKLabel className="fs-r fw-m" text={"New Tax Regime"} />
                                <DKLabel className="fs-xl fw-m" text={`Tax Liability: ${taxEstimate.amountNewRegime}`} />
                            </div>
                        </div>
                        <div className="row">
                            <DKIcon className="mr-s" src={ic_info_warning} />
                            <DKLabel text={"Please note that the tax liability is an estimate based on the current CTC."} />
                        </div>
                        <div className="row mt-xxl">
                            <DKButton
                                title={"CHANGE"}
                                className="bg-app text-white mr-l"
                                onClick={() => {
                                    updateState(SECTION.REGIME, setNewRegime, newRegime, -1, "newRegime", taxEstimate.newRegime);
                                    setTaxEstimate(null);
                                }}
                            />
                            <DKButton
                                title={"CANCEL"}
                                className="bg-app text-white"
                                onClick={() => {
                                    setTaxEstimate(null);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const getTaxEstimation = () => {
        const params = {
            financialYearStartDate: moment(getFinancialYearStartDate()).format(DATE_FORMAT.YYYYMMDD),
            userId: userId
        };
        showLoader();
        INComplianceService.getTaxEstimation(params).then(
            (response) => {
                removeLoader();
                if (response) {
                    setTaxEstimate({
                        ...response,
                        newRegime: newRegime.newRegime.value
                    });
                }
            }, (error) => {
                removeLoader();
            }
        );
    }

    const getCalculateIncomeTaxButton = () => {
        return (
            <div className="row mt-l">
                <DKButton
                    title={"CALCULATE INCOME TAX LIABILITY"}
                    className={getDisableCSSClass("bg-app text-white", true)}
                    onClick={() => {
                        getTaxEstimation();
                    }}
                />
            </div>
        )
    }

    const getActionButtons = () => {
        return (
            <div className="row mt-l">
                {(isMyPOI || PermissionUtils.hasAccess(MODULE.EMPLOYEE_POI, ACTION.SUBMIT)) &&
                    <DKButton
                        title={"SAVE AND SUBMIT"}
                        className={getDisableCSSClass("bg-app text-white mr-l", true)}
                        onClick={() => {
                            showConfirmDialog();
                        }}
                    />
                }
                {(isMyPOI || PermissionUtils.hasAccess(MODULE.EMPLOYEE_POI, [ACTION.DRAFT])) && !isRejectedApproval &&
                    <DKButton
                        title={"SAVE AS DRAFT"}
                        className={getDisableCSSClass("bg-app text-white mr-l", true)}
                        onClick={() => {
                            save(true);
                        }}
                    />
                }
                <DKButton
                    title={"CANCEL"}
                    className="bg-app text-white"
                    onClick={() => {
                        if (employeeData === "true") {
                            RouteManager.navigateToPage("/investments/employees-poi", `stage=${INVESTMENT_STAGE.ACTUAL}`);
                        } else {
                            RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD);
                        }
                    }}
                />
            </div>
        )
    }

    const getITDeclarationForm = () => {
        return (
            <div className="pb-xl">
                {getFinancialYearAndTaxRegime()}
                {getHouseRentDetailsSection()}
                {getHomeLoanSection()}
                {getRentalIncomeSection()}
                {get80CInvestmentSection()}
                {get80DInvestmentSection()}
                {getOtherInvestmentSection()}
                {getOtherIncomeSection()}
                {getCalculateIncomeTaxButton()}
                {getActionButtons()}
            </div>
        );
    }

    const getEmployeeNameSection = () => {
        return (
            <div className="row p-v-l">
                <DKLabel className="fs-xl fw-m" text={employeeName} />
            </div>
        )
    }

    return (
        <div className="parent-width">
            {employeeName && getEmployeeNameSection()}
            {getITDeclarationForm()}
            {taxEstimate && getIincomeTaxCalculationPopup()}
        </div>
    );
}

export default MyActual;
